import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
const Internationl2 = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setAnswers,
    answers,
    onSelect,
    setOnSelect,
    selected,
    setSelected,
    markSelected,
    data,
    setChartData,
    setAllCorrect
  } = props;
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);

  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#fff";
    }
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let indexToData = {2: 4, 3: 9, 4: 6, 5: 8 }
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        if(indexToData[ans]){
          console.log("indexToData[ans]", indexToData[ans], indexToData[ans] === 4 || indexToData[ans] === 5)
          if(ans === 4 || ans === 5){
          console.log("inside[ans]", ans, indexToData[ans])
            data[7].color = "red"
          }
          data[indexToData[ans]].color = "red"
        }
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };
  console.log("selected", selected)

  useEffect(() => {
    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });
    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted) {
      let tempAnswer = answers;
      if (answer) {
        // tempAnswer.push(true);
        // setAnswers(tempAnswer);
        if (questionAnswer.answer.includes(3)) {
          data[9].color = "green"
        }
        setAllCorrect(true);
      } else {
        // tempAnswer.push(false);
        // setAnswers(tempAnswer);
        let is_partial = false;
        // if (selected.length < questionAnswer.answer.length) {
          is_partial = notQuiteFun();
        // }
        data[9].color = "green"
        if (is_partial) {
          // setAnsweredPartialy(true);
        } else {
          // setAnsweredPartialy(false);
          setAllCorrect(false);
        }
      }
      setChartData(data);
    }
  }, [submitted]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    // height: isMobile ? 200 : 400,
    // width: isMobile ? 320 : 490,
    return (
      <div style={{ cursor: 'pointer' }}>
        <div
          className={classes.shape1Major}
          style={{
            clipPath: "polygon(100% 0, 0 0, 50% 100%)",
            backgroundColor: submitted
              ? correctAnswer.includes(1)
                ? "green"
                : selected.includes(1)
                ? "red"
                : "#fff"
              : selected.includes(1)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(1)
              ? console.log("hhhh")
              : !checkSelection(1) && resetBackground
          }
          onMouseOver={
            selected.includes(1)
              ? console.log("1")
              : !checkSelection(1) && changeBackground
          }
          onClick={() => markSelected(1)}
        />

         <div
          className={classes.shape2Major}
          style={{
            clipPath: "polygon(100% 100%, 0 0, 0 100%)",
            backgroundColor: submitted
              ? correctAnswer.includes(2)
                ? "green"
                : selected.includes(2)
                ? "red"
                : "#fff"
              : selected.includes(2)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(2)
              ? console.log("hhhh")
              : !checkSelection(2) && resetBackground
          }
          onMouseOver={
            selected.includes(2)
              ? console.log("1")
              : !checkSelection(2) && changeBackground
          }
          onClick={() => markSelected(2)}
        />

        <div
          className={classes.shape3Major}
          style={{
            float: "left",
            clipPath: "polygon(100% 100%, 100% 0, 0 50%)",
            backgroundColor: submitted
              ? correctAnswer.includes(3)
                ? "green"
                : selected.includes(3)
                ? "red"
                : "#fff"
              : selected.includes(3)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(3)
              ? console.log("hhhh")
              : !checkSelection(3) && resetBackground
          }
          onMouseOver={
            selected.includes(3)
              ? console.log("3")
              : !checkSelection(3) && changeBackground
          }
          onClick={() => markSelected(3)}
        />

        <div
          className={classes.shape4Major}
          style={{
            // backgroundColor: 'red',
            clipPath: "polygon(100% 100%, 0 0, 0 100%)",
            // width: "97%",
            // marginTop: 90,
            backgroundColor: submitted
              ? correctAnswer.includes(4)
                ? "green"
                : selected.includes(4)
                ? "red"
                : "#fff"
              : selected.includes(4)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(4)
              ? console.log("hhhh")
              : !checkSelection(4) && resetBackground
          }
          onMouseOver={
            selected.includes(4)
              ? console.log("3")
              : !checkSelection(4) && changeBackground
          }
          onClick={() => markSelected(4)}
        />

        <div
          className={classes.shape5Major}
          style={{
            // backgroundColor: 'red',
            clipPath: "polygon(100% 0, 0 0, 0 100%)",
            backgroundColor: submitted
              ? correctAnswer.includes(5)
                ? "green"
                : selected.includes(5)
                ? "red"
                : "#fff"
              : selected.includes(5)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(5)
              ? console.log("hhhh")
              : !checkSelection(5) && resetBackground
          }
          onMouseOver={
            selected.includes(5)
              ? console.log("3")
              : !checkSelection(5) && changeBackground
          }
          onClick={() => markSelected(5)}
        />

        <div
          className={classes.shape6Major}
          style={{
            // backgroundColor: 'red',
            clipPath: "polygon(100% 100%, 100% 0, 0 50%)",
            backgroundColor: submitted
              ? correctAnswer.includes(6)
                ? "green"
                : selected.includes(6)
                ? "red"
                : "#fff"
              : selected.includes(6)
              ? "#00b1d9"
              : "#fff",
          }}
          onMouseOut={
            selected.includes(6)
              ? console.log("hhhh")
              : !checkSelection(6) && resetBackground
          }
          onMouseOver={
            selected.includes(6)
              ? console.log("3")
              : !checkSelection(6) && changeBackground
          }
          onClick={() => markSelected(6)}
        />
      </div>
    );
  };

  return <Grid style={{ cursor: 'pointer' }}>{demandCurveResponsive()}</Grid>;
};

export default withStyles(styles)(Internationl2);
